import type { AnalyticsDataPoint } from '../components/ChartContainer';

// Helper to aggregate data by granularity
export const aggregateByGranularity = (
  data: AnalyticsDataPoint[],
  granularity: 'daily' | 'weekly' | 'monthly'
): AnalyticsDataPoint[] => {
  if (granularity === 'daily' || !data.length) return data;

  const grouped: { [key: string]: AnalyticsDataPoint[] } = {};

  data.forEach(point => {
    const date = new Date(point.code);
    let key: string;

    if (granularity === 'weekly') {
      // Get start of week (Monday)
      const startOfWeek = new Date(date);
      const day = startOfWeek.getUTCDay();
      const diff = startOfWeek.getUTCDate() - day + (day === 0 ? -6 : 1);
      startOfWeek.setUTCDate(diff);
      key = startOfWeek.toISOString().split('T')[0];
    } else if (granularity === 'monthly') {
      // Get start of month
      key = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-01`;
    } else {
      key = point.code;
    }

    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(point);
  });

  // Aggregate grouped data
  return Object.entries(grouped)
    .map(([key, points]) => ({
      code: key,
      value: points.reduce((sum, p) => sum + p.value, 0),
      volume: points.reduce((sum, p) => sum + (p.volume || 0), 0),
      currency: points[0]?.currency,
    }))
    .sort((a, b) => new Date(a.code).getTime() - new Date(b.code).getTime());
};
